import smoothscroll from 'smoothscroll-polyfill';
// Remove as soon as stopping support for iOS < 12.2
import 'intersection-observer';

smoothscroll.polyfill();
